export default __webpack_public_path__ + "static/media/Hammer.571b5bb5.webp";